import React from 'react';
import {WeaSearchGroup} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';
//import EField from './base/EField';
import ENewsMould from './base/ENewsMould';
import ERemindMode from './base/ERemindMode';
import DataSourceTable from './base/DataSourceTable';

// 文档中心
class Content_dy extends React.Component {
    render() {
        const {hpid, eid, ebaseid, eShareLevel, synergyParams,dyParams = [],sebaseid} = this.props;

        let __DataSourceTable = <div></div>;
        if (eShareLevel == '2') {
            __DataSourceTable = <DataSourceTable ref="dataSourceTable" hpid={hpid} eid={eid} ebaseid={sebaseid} {...this.props.eTabs} synergyParams={synergyParams}/>;
        }
        let settingInfo = dyParams.map(dpitem => {
            switch (dpitem.type) {
                case 'EShowNum':
                    return <EShowNum ref="eShowNum" value={this.props.eShowNum}/>;
                    break;
                case 'ELinkMode':
                    return <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>;
                    break;
                case 'ERemindMode':
                    return <ERemindMode ref="eRemindMode" value={this.props.eRemindMode}/>;
                    break;
                default:
                    return null
            }
        })
        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>


                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {settingInfo}
                    {/*<EShowNum ref="eShowNum" value={this.props.eShowNum}/>*/}
                    {/*<ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>*/}
                    {/*<ERemindMode ref="eRemindMode" value={this.props.eRemindMode}/>*/}
                </WeaSearchGroup>
                {__DataSourceTable}
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentRemindMode: this.refs['eRemindMode'].getSaveValues(),
            eContentTabWidth: {tabwidth: this.props.etabwidth, methodvalue: this.props.methodvalue},
            eTabs: this.refs['dataSourceTable'] ? this.refs['dataSourceTable'].getSaveValues() : {}
        };
    }
}

export default Content_dy;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_dy.js